export default "__VITE_ASSET__ec3775b6__"